export default __webpack_public_path__ + "static/media/SOL.9707b35b.svg";